<template>
    <div class="publication__editor content-width" ref="editor">
        <div class="publication__editor-wrap  d-flex">

        <div class="publication__editor-item d-flex">
            <div class="publication__fieldset d-flex">
                <div class="publication__fieldset-title">
                    {{$store.getters.t('volunteer_backend_settings_component_profile_photo')}}
                </div>
                <div class="publication__fieldset-placeholder d-flex">
                    <div class="publication__fieldset-placeholder-card">

                        <div class="publication__fieldset-upload">
                            <label v-if="!cropperImgSrc" class="publication__fieldset-upload-btn d-flex">
                                <input type="file" accept=".jpeg,.png,.jpg" @change="processFile($event)">
                                <img src="/assets/images/icons/publication-add.svg" alt="">
                                {{$store.getters.t('volunteer_backend_settings_component_upload_photo')}}

                            </label>

                            <div class="publication__fieldset-cropper" v-if="cropperImgSrc">
                                <vue-cropper
                                    ref="cropper"
                                    :src="cropperImgSrc"

                                    @ready="handleHeight"
                                    style="position: relative; height: 216px; width: 100%; overflow: hidden"
                                    :minCropBoxWidth="100"
                                    :minCropBoxHeight="100"

                                    alt="Source Image"
                                    :viewMode="1"
                                    :aspectRatio="1.5 / 1"

                                    dragMode="move"

                                    preview=".publication__fieldset-preview"
                                ></vue-cropper>

                                <div class="publication__fieldset-cropper-nav mt-3 d-flex">
                                    <button  class="btn btn--sm btn--round" @click.prevent="flip(true, false)">
                                        <img src="/assets/images/icons/flipH.svg" alt="">
                                    </button>
                                    <button class="btn btn--sm btn--round" @click.prevent="flip(false, true)">
                                        <img src="/assets/images/icons/flipV.svg" alt="">
                                    </button>
                                    <button class="btn btn--sm btn--round" @click.prevent="rotate(90)">
                                        <img src="/assets/images/icons/rotateF.svg" alt="">
                                    </button>
                                    <button  class="btn btn--sm btn--round" @click.prevent="rotate(-90)">
                                        <img src="/assets/images/icons/rotateB.svg" alt="">
                                    </button>
                                </div>

                                <span @click="cropperImgSrc = null" v-if="cropperImgSrc" aria-hidden="true" class="btn btn--sm btn--round mt-3 ">{{$store.getters.t('form_avatar_cancel')}}</span>
                                <span @click="cropImage" v-if="cropperImgSrc" aria-hidden="true" class="btn btn--sm btn--round mt-3 pull-right">{{$store.getters.t('form_avatar_done')}}</span>

                            </div>


                        </div>

                        <div class="text-danger" v-if="$v.avatar.$error || !$v.cropperImgSrc.$custom">{{$store.getters.t('publication_select_avatar')}}</div>
                        <div class="text-danger" v-if="!$v.avatar.$size">{{$store.getters.t('publication_avatar_too_large_5mb')}}</div>

                        <p>
                            {{$store.getters.t('volunteer_backend_settings_component_jpg_png_up_to_5mb')}}
                        </p>
                        <p>
                            {{$store.getters.t('publication_max_image_size_5mb')}}
                        </p>

                    </div>
                </div>
            </div>
        </div>

        <div class="publication__editor-item">
            <div class="publication__fieldset">
                <div class="publication__fieldset-title">{{$store.getters.t('publication_pet_preview_pet_name')}}</div>
                <div class="publication__fieldset-input">
                    <input type="text" v-model="$v.name.$model" :placeholder="$store.getters.t('publication_pet_preview_enter_pet_name')">
                </div>
                <div class="text-danger" v-show="$v.name.$error">{{$store.getters.t('publication_pet_preview_invalid_value')}}</div>
            </div>
            <div class="publication__fieldset publication__fieldset--textarea-medium">
                <div class="publication__fieldset-title">{{$store.getters.t('publication_pet_preview_catalog_subtitle')}}</div>
                <div class="publication__fieldset-input">
                    <textarea v-model="$v.ad_title.$model" :placeholder="$store.getters.t('publication_pet_preview_enter_catalog_text')"></textarea>
                </div>
                <div class="text-danger" v-show="$v.ad_title.$error">{{$store.getters.t('publication_pet_preview_invalid_value')}}</div>
            </div>
            <div class="publication__fieldset publication__fieldset--textarea-large" v-if="provideStep === server.idx">
                <div class="publication__fieldset-title">{{$store.getters.t('publication_pet_preview_pet_info')}}</div>
                <quill-editor
                    class="publication__fieldset-input"
                    v-model="description"
                    :options="editorOption"
                />
                <div class="text-danger" v-show="$v.description.$error">{{$store.getters.t('publication_pet_preview_invalid_value')}}</div>
            </div>
        </div>
        <div class="publication__editor-item d-flex">
            <div class="publication__fieldset d-flex">
                <div class="publication__fieldset-title">
                    {{$store.getters.t('publication_preview_title')}}
                </div>
                <div class="publication__fieldset-placeholder d-flex">
                    <div class="publication__fieldset-placeholder-card">

                        <div class="publication__fieldset-placeholder-wrapper">
                            <div class="publication__fieldset-placeholder-avatar">
                                <div class="publication__fieldset-preview" alt="" v-if="cropperImgSrc"></div>
                                <img class="publication__fieldset-image" :src="petAvatar" v-if="petAvatar && !cropperImgSrc"/>

                            </div>
                            <div class="publication__fieldset-placeholder-error d-flex" v-if="!$v.avatar.$size">
                                {{$store.getters.t('publication_gallery_image_too_large')}}
                            </div>
                        </div>


                        <div class="publication__fieldset-placeholder-title d-flex">
                            <div class="publication__fieldset-placeholder-name">{{ name || $store.getters.t('publication_pet_preview_enter_pet_name') }}</div>
                            <div class="publication__fieldset-placeholder-location">
                                <span class="lnr lnr-map-marker"></span>
                                {{selectedCity.name}}
                            </div>
                        </div>

                        <div class="publication__fieldset-placeholder-description">{{ ad_title || $store.getters.t('publication_pet_preview_enter_catalog_text') }}</div>
                        <div class="publication__fieldset-placeholder-description publication__fieldset-placeholder-description--biggest" v-if="description" v-html="description"></div>
                        <div class="publication__fieldset-placeholder-description publication__fieldset-placeholder-description--biggest" v-else>{{$store.getters.t('publication_pet_preview_enter_common_text')}}</div>

                    </div>
                </div>
            </div>
        </div>
    </div>
    </div>
</template>

<script>

import { quillEditor } from 'vue-quill-editor';

import { required, maxLength, requiredIf } from 'vuelidate/lib/validators';
import StateMixin from "../mixins/StateMixin";

export default {
    name: "PublicationEditPreview",
    props: ['server'],
    inject: ['step'],
    mixins: [StateMixin],
    components: { quillEditor },
    data(){
        return{
            cropperImgSrc: null,
            croppedImg: null,
            editorOption: {
                modules: {
                    toolbar: [['bold', 'italic', 'underline','blockquote'],[{ 'list': 'ordered'}, { 'list': 'bullet' }]]
                },
                placeholder: this.$store.getters.t('publication_pet_preview_enter_common_text'),
                theme: 'snow'
            },
        }
    },
    computed:{
        provideStep(){
            return this.step();
        },

        avatarPath: {
            get() { return this.GET_BY_KEY('avatarPath') },
            set( val ){
                this.SET_PET_BY_KEY({ key: 'avatarPath', data: val })
            }
        },
        avatar: {
            get() { return this.GET_BY_KEY('avatar') },
            set( val ){
                this.SET_PET_BY_KEY({ key: 'avatar', data: val })
            }
        },

        petAvatar: {
            get() { return this.GET_BY_KEY('petAvatar') },
            set( val ){
                this.SET_PET_BY_KEY({ key: 'petAvatar', data: val })
            }
        },

        name: {
            get() { return this.GET_BY_KEY('name') },
            set( val ) {
                this.SET_PET_BY_KEY({key: 'name', data: val})
            }
        },

        ad_title: {
            get() { return this.GET_BY_KEY('ad_title') },
            set( val ) {
                this.SET_PET_BY_KEY({key: 'ad_title', data: val})
            }
        },

        description: {
            get() { return this.GET_BY_KEY('description') },
            set( val ) {
                this.SET_PET_BY_KEY({key: 'description', data: val})
            }
        },

        selectedCity(){ return this.GET_BY_KEY('selectedCity') },

    },

    methods:{
        handleHeight(){
            if(this.$refs.editor)
                this.$parent.handleSliderHeight( this.$refs.editor.clientHeight );
        },

        flip( _horizontal, _vertical ){

            const { scaleX, scaleY } = this.$refs.cropper.getImageData();

            if( _horizontal ){

                this.$refs.cropper.scaleX( scaleX === 1 ? -1 : 1 );

                return;
            }

            if( _vertical ){

                this.$refs.cropper.scaleY( scaleY === 1 ? -1 : 1 );

                return;
            }

        },
        rotate( _degree ){

            this.$refs.cropper.rotate( _degree )

        },


        processFile(e) {

            const file = e.target.files[0];

            if (!file.type.includes("image/")) {
                alert(this.$store.getters.t('user_settings_select_image_file'));
                return;
            }

            if (typeof FileReader === "function") {

                const reader = new FileReader();

                reader.onload = event => {
                    this.cropperImgSrc = event.target.result;
                    if (this.$refs.cropper) {
                        this.$refs.cropper.replace(event.target.result);
                    }

                };

                reader.readAsDataURL(file);

            } else {
                alert(this.$store.getters.t('common_filereader_not_supported'));
            }

        },

        cropImage() {
            let croppedCanvas;

            // Crop
            croppedCanvas = this.$refs.cropper.getCroppedCanvas();

            // Show
            this.croppedImg = croppedCanvas.toDataURL()
            this.cropperImgSrc = null;
            this.petAvatar = this.croppedImg;

            let block = this.croppedImg.split(";");
            let contentType = block[0].split(":")[1];
            let realData = block[1].split(",")[1];
            this.avatar = this.b64toBlob(realData, contentType);

            if( this.avatarPath ) this.avatarPath = null;

        },

        b64toBlob(b64Data, contentType, sliceSize) {
            contentType = contentType || '';
            sliceSize = sliceSize || 512;
            let byteCharacters = atob(b64Data);
            let byteArrays = [];

            for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
                let slice = byteCharacters.slice(offset, offset + sliceSize);

                let byteNumbers = new Array(slice.length);
                for (var i = 0; i < slice.length; i++) {
                    byteNumbers[i] = slice.charCodeAt(i);
                }

                let byteArray = new Uint8Array(byteNumbers);

                byteArrays.push(byteArray);
            }

            return new Blob(byteArrays, {type: contentType});
        },

        isValid(){
            this.$v.$touch();

            if( this.$v.$invalid ){
                this.$emit('parent-update', false );
                return false
            }

            this.$emit('parent-update', true )

            return true

        }
    },

    watch:{
        cropperImgSrc(val){
            if( ! val ){
                this.$parent.handleSliderHeight()
            }
        },
    },

    validations: {
        avatar: {

            required: requiredIf( function() {
                return ! this.avatarPath
            } ),

            $size( value ) {

                if( ! value || ! value.size ) return  true;

                return value.size < 20971520;

            }

        },

        cropperImgSrc:{
            $custom( value ) {

                if ( ! value  ) return true;

                return ! this.avatar && ! this.avatarPath;

            }
        },
        name:        { required },
        ad_title:    { required, maxLength: maxLength(80) },
        description: { required, maxLength: maxLength(3000) },
    }

}
</script>

<style scoped>

</style>
